import { AdjustmentTypeDroOpts } from "presentation/constant/DropDownOptions/Charge/AdjustmentTypeDroOpts";
import { docTypeDropdownOption, exchangeRateRefDateDropdownOption } from "presentation/constant/DropDownOptions/StaticDropdownOptions";
import { ExchangeRateRefDateMappingConstant } from "presentation/constant/ExchangeRateRefDateMapping/ExchangeRateRefDateMappingConstant";
import { useExchangeRateRefDateMappingVM } from "presentation/hook/ExchangeRateRefDateMapping/useExchangeRateRefDateMappingVM";
import { useExchangeRateRefDateMappingTracked } from "presentation/store/ExchangeRateRefDateMapping/ExchangeRateRefDateMappingProvider";
import { CriteriaItemContainer } from "presentation/view/components/CriteriaItemContainer";
import { NbisCommonField } from "presentation/view/components/NbisCommonField";
import NumberInputComponent from "presentation/view/components/NumberInputComponent";
import { useCallback, useMemo } from "react";
import { FieldType, HPHCheckbox, IFieldValue } from "veronica-ui-component/dist/component/core";
import { SidebarCaption, SidebarTitle, StyledSidebar } from "veronica-ui-component/dist/component/core/styled/uiFramework.styled";
import ExchangeRateRefDateMappingTitleBar from "./ExchangeRateRefDateMappingTitleBar";
export const ExchangeRateRefDateMappingFormPanel = () => {
    const [exchangeState] = useExchangeRateRefDateMappingTracked();
    const exchangeVM = useExchangeRateRefDateMappingVM();
    const { currentSelectedRow, masterState } = exchangeState;
    const { editingEntity, isAdd, isRead, isEditable, isSaveClicked, allFormState } = masterState;
    const SCREEN_CONSTANT = ExchangeRateRefDateMappingConstant.Table;

    const currentEntity = isRead ? currentSelectedRow : editingEntity;

    const onNumberFieldChange = useCallback((e: any, fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) => {
        exchangeVM.onFieldChange(fieldKey, fieldValue, fFullValue);
    }, [exchangeVM]);

    const memoCustomerCode = useMemo(() =>
        <div className='im-flex-row-item' style={{ width: "330px", marginBottom: "24px" }}>
            <NbisCommonField
                errorMessage={allFormState ? allFormState["customerCode"] : ""}
                isReadOnly={!(isEditable || isAdd)}
                isShowOptional={false}
                readOnlyValue={currentEntity?.customerCode || ''}
                fieldValue={currentEntity?.customerCode}
                fieldLabel={SCREEN_CONSTANT.CUSTOMER_CODE}
                isSaveClicked={isSaveClicked}
                fieldType={FieldType.DROPDOWN}
                fieldKey={'customerCode'}
                isShowMissingError={true}
                maxLength={60}
                options={exchangeState.dynamicOptions.customerCodeDropdownOptions}
                requiredFieldList={[]}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    exchangeVM.onFieldChange(fieldKey, fieldValue && fieldValue.toString(), fFullValue)} />
        </div>
        , [allFormState, isEditable, isAdd, currentEntity?.customerCode, SCREEN_CONSTANT.CUSTOMER_CODE, isSaveClicked, exchangeState.dynamicOptions.customerCodeDropdownOptions, exchangeVM])

    const memoDocType = useMemo(() =>
        <div className='im-flex-row-item' style={{ width: "330px", marginBottom: "24px" }}>
            <NbisCommonField
                errorMessage={allFormState ? allFormState["docType"] : ""}
                isReadOnly={!(isEditable || isAdd)}
                isShowOptional={false}
                readOnlyValue={currentEntity?.docType || ''}
                fieldValue={currentEntity?.docType}
                fieldLabel={SCREEN_CONSTANT.DOC_TYPE}
                isSaveClicked={isSaveClicked}
                fieldType={FieldType.DROPDOWN}
                fieldKey={'docType'}
                isShowMissingError={true}
                maxLength={60}
                options={docTypeDropdownOption}
                requiredFieldList={[]}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    exchangeVM.onFieldChange(fieldKey, fieldValue && fieldValue.toString(), fFullValue)} />
        </div>
        , [allFormState, isEditable, isAdd, currentEntity?.docType, SCREEN_CONSTANT.DOC_TYPE, isSaveClicked, exchangeVM])

    const memoAdjType = useMemo(() =>
        <div className='im-flex-row-item' style={{ width: "330px", marginBottom: "24px" }}>
            <NbisCommonField
                errorMessage={allFormState ? allFormState["adjType"] : ""}
                isReadOnly={!(isEditable || isAdd)}
                isShowOptional={false}
                readOnlyValue={currentEntity?.adjType || ''}
                fieldValue={currentEntity?.adjType}
                fieldLabel={SCREEN_CONSTANT.ADJ_TYPE}
                isSaveClicked={isSaveClicked}
                fieldType={FieldType.DROPDOWN}
                fieldKey={'adjType'}
                isShowMissingError={true}
                maxLength={60}
                options={AdjustmentTypeDroOpts().getAdjustmentTypeModel()}
                requiredFieldList={[]}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    exchangeVM.onFieldChange(fieldKey, fieldValue && fieldValue.toString(), fFullValue)} />
        </div>
        , [allFormState, isEditable, isAdd, currentEntity?.adjType, SCREEN_CONSTANT.ADJ_TYPE, isSaveClicked, exchangeVM])

    const memoReferenceDate = useMemo(() =>
        <div className='im-flex-row-item' style={{ width: "330px", marginBottom: "24px" }}>
            <NbisCommonField
                errorMessage={allFormState ? allFormState["exchangeRateRefDateAttr"] : ""}
                isReadOnly={!(isEditable || isAdd)}
                isShowOptional={false}
                readOnlyValue={currentEntity?.exchangeRateRefDateAttr || ''}
                fieldValue={currentEntity?.exchangeRateRefDateAttr}
                fieldLabel={SCREEN_CONSTANT.EXCHANGE_RATE_REF_DATE_ATTR}
                isSaveClicked={isSaveClicked}
                fieldType={FieldType.DROPDOWN}
                fieldKey={'exchangeRateRefDateAttr'}
                isShowMissingError={true}
                maxLength={60}
                options={exchangeRateRefDateDropdownOption}
                requiredFieldList={[]}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    exchangeVM.onFieldChange(fieldKey, fieldValue && fieldValue.toString(), fFullValue)} />
        </div>
        , [allFormState, isEditable, isAdd, currentEntity?.exchangeRateRefDateAttr, SCREEN_CONSTANT.EXCHANGE_RATE_REF_DATE_ATTR, isSaveClicked, exchangeVM])

    const memoAdjustment = useMemo(() =>
        <div className='im-flex-row-item' style={{ width: "330px", marginBottom: "24px" }}>
            <NumberInputComponent
                label={SCREEN_CONSTANT.ADJUSTMENT}
                maxLength={13}
                fieldName={"adjustment"}
                value={currentEntity?.adjustment ?? ''}
                errorMessage={allFormState?.adjustment ?? ''}
                disabled={!(isEditable || isAdd)}
                decimalPlaces={2}
                onChange={(e: any, fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    onNumberFieldChange(e, fieldKey, fieldValue, fFullValue)}
            />
        </div>
        , [SCREEN_CONSTANT.ADJUSTMENT, allFormState?.adjustment, currentEntity?.adjustment, isAdd, isEditable, onNumberFieldChange])

    const memoActiveInd = useMemo(() =>
        <>
            <div className='im-flex-row-item' style={{ width: "150px", marginBottom: "24px" }}>

                <NbisCommonField
                    fieldKey={"activeInd"}
                    requiredFieldList={[]}
                    fieldLabel={SCREEN_CONSTANT.ACTIVE_IND}
                    fieldType={FieldType.TEXT}
                    isReadOnly={true}
                    onFieldChange={() => { }} />
                <HPHCheckbox
                    label={""}
                    checked={currentEntity?.activeInd === 'Y'}
                    disabled={!(isEditable || isAdd)}
                    onChange={(e) => exchangeVM.onCheckboxChange(e.checked, "activeInd")}
                />
            </div>
        </>
        , [SCREEN_CONSTANT.ACTIVE_IND, currentEntity?.activeInd, exchangeVM, isAdd, isEditable])

    const memoEditPanelTitleBar = useMemo(() => {
        return <ExchangeRateRefDateMappingTitleBar />
    }, [])
    return <StyledSidebar style={{ width: '100%', height: "100%", border: 'none', backgroundColor: '#FFFFFF', overflow: 'auto', padding: '0' }} position='right'>
        {/* Header part of add or edit record */}
        {memoEditPanelTitleBar}
        {/* Readable and Editable Form */}
        <div className={'add-edit-form'} style={{ height: 'calc(100vh - 125px)', maxHeight: 'calc(100vh - 125px)', overflow: 'auto' }}>
            <div className="flex-row-auto">
                <div className={'flex-row-item'}>
                    <div className={'im-flex-row'}>
                        <div className={'flex-row-item-stretch'}>
                            <SidebarTitle>
                                {isAdd && "New Exchange Rate Reference Date Mapping"}
                                {!isAdd && currentEntity.customerCode}</SidebarTitle>
                            {<SidebarCaption>"All fields are required unless indicated as 'optional'"</SidebarCaption>}
                        </div>
                    </div>

                    <CriteriaItemContainer>
                        {memoCustomerCode}
                        {memoDocType}
                        {memoAdjType}
                    </CriteriaItemContainer>
                    <CriteriaItemContainer>
                        {memoReferenceDate}
                        {memoAdjustment}
                        {memoActiveInd}
                    </CriteriaItemContainer>
                </div>
            </div>
        </div>
        {/* Readable and Editable Form */}
    </StyledSidebar>
}

